import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const examinationSchema = new schema.Entity(
  'examinations',
  {},
  {
    idAttribute: 'idname',
  }
)

export const examinationInfoSchema = new schema.Entity(
  'examination_infos',
  {},
  {
    idAttribute: 'id',
  }
)

export const examinationPaperQuestionSchema = new schema.Entity(
  'examination_paper_questions',
  {},
  {
    idAttribute: 'id',
  }
)

export const examinationQuestionSetSchema = new schema.Entity(
  'exam_question_sets',
  {},
  {
    idAttribute: 'id',
  }
)

export const examinationPaperSchema = new schema.Entity(
  'examination_papers',
  {
    examination_paper_questions: [examinationPaperQuestionSchema],
  },
  {
    idAttribute: 'id',
  }
)

export const exam_getExaminations_Api = {
  name: 'exam_getExaminations',
  backend: `Route::get('examinations/{type}/{id}/get-examinations', 'ExaminationController@getExaminations');`,
  root: API_ROOT_URL,
  path: '/examinations/:type/:id/get-examinations',
  method: 'GET',
  // hide_expired: cờ riêng cho widget teaser "Kỳ thi" ở trang tổ chức (OrganizationExaminations.js) -
  // loại hẳn kỳ thi đã đóng khỏi kết quả, xem giải thích ở ExaminationController::getExaminations().
  paramsFields: ['keyword', 'status', 'hide_expired'],
  schema: examinationSchema,
  transform: createListTransform(examinationSchema),
}

export const exam_getExaminationById_Api = {
  name: 'exam_getExaminationById',
  backend: `Route::get('examinations/examination/{id}/get', 'ExaminationController@getById');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/get',
  method: 'GET',
  schema: examinationSchema,
  transform: createTransform(examinationSchema, 'data'),
}

export const exam_createExaminationPaper_Api = {
  name: 'exam_createExaminationPaper',
  backend: `Route::post('examination-papers/examination/{id}/init-examination-paper', 'ExaminationPaperController@createExaminationPaper');`,
  root: API_ROOT_URL,
  path: '/examination-papers/examination/:id/init-examination-paper',
  method: 'POST',
  schema: examinationPaperSchema,
  transform: createTransform(examinationPaperSchema, 'data'),
}

export const exam_deleteExaminationPaper_Api = {
  name: 'exam_createExaminationPaper',
  backend: `Route::post('examination-papers/examination-paper/{id}/delete', 'ExaminationPaperController@deleteExaminationPaper');`,
  root: API_ROOT_URL,
  path: '/examination-papers/examination-paper/:id/delete',
  method: 'POST',
  schema: examinationPaperSchema,
  transform: createTransform(examinationPaperSchema, 'data'),
}

export const exam_getExaminationPaperById_Api = {
  name: 'exam_getExaminationPaperById',
  backend: `Route::get('examination-papers/examination-paper/{id}/get', 'ExaminationPaperController@getExaminationPaperById');`,
  root: API_ROOT_URL,
  path: '/examination-papers/examination-paper/:id/get',
  method: 'GET',
  schema: examinationPaperSchema,
  transform: createTransform(examinationPaperSchema, 'data'),
}

export const exam_getExaminationPapers_Api = {
  name: 'exam_getExaminationPapers',
  backend: `Route::get('examinations/{type}/{id}/get-examination-papers', 'ExaminationController@getExaminationPapers'); // sort_by: name, date, filter examination_id, search: keyword`,
  root: API_ROOT_URL,
  path: '/examinations/:type/:id/get-examination-papers',
  method: 'GET',
  paramsFields: ['result_status', 'sort_by', 'keyword', 'examination_id'],
  schema: examinationPaperSchema,
  transform: createListTransform(examinationPaperSchema),
}

export const exam_setAsAnswer_Api = {
  name: 'exam_setAsAnswer',
  backend: `Route::post('examination-papers/examination-paper-question/{id}/set-as-answer', 'ExaminationPaperController@setAsAnswer');
  // examination_paper_question_answer_ids`,
  root: API_ROOT_URL,
  path: '/examination-papers/examination-paper-question/:id/set-as-answer',
  method: 'POST',
  schema: examinationPaperQuestionSchema,
  transform: createTransform(examinationPaperQuestionSchema, 'data'),
}

export const exam_submitExaminationPaper_Api = {
  name: 'exam_submitExaminationPaper',
  backend: `Route::post('examination-papers/examination/{id}/submit-examination-paper', 'ExaminationPaperController@submitExaminationPaper');`,
  root: API_ROOT_URL,
  path: '/examination-papers/examination-paper/:id/submit-examination-paper',
  method: 'POST',
  schema: examinationPaperSchema,
  transform: createTransform(examinationPaperSchema, 'data'),
}

export const exam_getExaminationInfos_Api = {
  name: 'exam_getExaminationInfos',
  backend: `Route::get('examinations/examination/{id}/get-examination-infos', 'ExaminationController@getExaminationInfos');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/get-examination-infos',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'answer_types'],
  schema: examinationInfoSchema,
  transform: createListTransform(examinationInfoSchema),
}

export const exam_getExaminationInfoAnswers_Api = {
  name: 'exam_getExaminationInfoAnswers',
  backend: `Route::get('examinations/examination-info/{id}/get-examination-info-answers', 'ExaminationController@getExaminationInfoAnswers');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info/:id/get-examination-info-answers',
  method: 'GET',
  schema: examinationInfoSchema,
  transform: createListTransform(examinationInfoSchema),
}

export const exam_getExaminationReportOnTopResult_Api = {
  name: 'exam_getExaminationReportOnTopResult',
  backend: `Route::get('examinations/examination/{id}/report/get-top-results', 'ExaminationController@getExaminationReportOnTopResult');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/report/get-top-results',
  method: 'GET',
  paramsFields: [
    'examination_id',
    'examination_info_ids',
    'examination_info_answer_id',
  ],
}

export const exam_getTop10ExaminationPapers_Api = {
  name: 'exam_getTop10ExaminationPapers_Api',
  backend: `Route::get('examinations/examination/{id}/report/get-top-10', 'ExaminationController@getTop10ExaminationPapers');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/report/get-top-10',
  method: 'GET',
  paramsFields: ['examination_id'],
}

export const exam_getExaminationReportOnInfoSummary_Api = {
  name: 'exam_getExaminationReportOnInfoSummary',
  backend: `Route::get('examinations/examination/{id}/report/get-on-info-summary', 'ExaminationController@getExaminationReportOnInfoSummary');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/report/get-on-info-summary',
  method: 'GET',
  paramsFields: ['examination_id', 'examination_info_id'],
}

export const exam_getExaminationReportGroupByInfoSummary_Api = {
  name: 'exam_getExaminationReportGroupByInfoSummary_Api',
  backend: `Route::get('examinations/examination/{id}/report/get-on-exam-info-summary', 'ExaminationController@getExaminationReportOnExamInfoSummary');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/report/get-on-exam-info-summary',
  method: 'GET',
  paramsFields: [
    'examination_id',
    'examination_info_id',
    'examination_info_answer_id',
  ],
}

export const exam_getExaminationInfoStatReport_Api = {
  name: 'exam_getExaminationInfoStatReport_Api',
  backend: `Route::get('examinations/examination/{id}/report/get-aggregate-stats', 'ExaminationController@getExaminationInfoStatReport');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/report/get-aggregate-stats',
  method: 'GET',
  paramsFields: ['examination_info_id'],
}

export const exam_getExaminationInfoList_Api = {
  name: 'exam_getExaminationInfoList',
  backend: `Route::get('examinations/examination/{id}/get-examination-info-list', 'ExaminationController@getExaminationInfoList');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/get-examination-info-list',
  method: 'GET',
  paramsFields: ['keyword'],
}

export const exam_getExamQuestionSets_Api = {
  name: 'exam_getExamQuestionSets',
  backend: `Route::get('exam-questions/exam-question-sets/{type}/{id}/get-exam-question-sets', 'ExamQuestionController@getExamQuestionSets');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-sets/:type/:id/get-exam-question-sets',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'examination_id'],
  schema: examinationQuestionSetSchema,
  transform: createListTransform(examinationQuestionSetSchema),
}

export const exam_deleteExamQuestionSet_Api = {
  name: 'exam_deleteExamQuestionSet',
  backend: `Route::post('exam-questions/exam-question-sets/{id}/delete', 'ExamQuestionController@deleteExamQuestionSet');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-sets/:id/delete',
  method: 'POST',
  schema: examinationQuestionSetSchema,
  transform: createTransform(examinationQuestionSetSchema, 'data'),
}

export const exam_editExamQuestionSet_Api = {
  name: 'exam_editExamQuestionSet',
  backend: `Route::post('exam-questions/exam-question-sets/{id}/edit', 'ExamQuestionController@editExamQuestionSet');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-sets/:id/edit',
  method: 'POST',
  schema: examinationQuestionSetSchema,
  transform: createTransform(examinationQuestionSetSchema, 'data'),
}

export const exam_createExamQuestionSet_Api = {
  name: 'exam_createExamQuestionSet',
  backend: `Route::post('exam-questions/exam-question-sets/{type}/{id}/add', 'ExamQuestionController@createExamQuestionSet');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-sets/:type/:id/add',
  method: 'POST',
  schema: examinationQuestionSetSchema,
  transform: createTransform(examinationQuestionSetSchema, 'data'),
}

export const exam_resetExamination_Api = {
  name: 'exam_resetExamination',
  backend: `Route::post('examinations/examination/{id}/reset', 'ExaminationController@resetExamination');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/reset',
  method: 'POST',
  schema: examinationSchema,
  transform: createTransform(examinationSchema, 'data'),
}

export const exam_deleteExamination_Api = {
  name: 'exam_deleteExamination',
  backend: `Route::post('examinations/examination/{id}/delete', 'ExaminationController@deleteExamination');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/delete',
  method: 'POST',
  schema: examinationSchema,
  transform: createTransform(examinationSchema, 'data'),
}

export const exam_editExamination_Api = {
  name: 'exam_editExamination',
  backend: `Route::post('examinations/examination/{id}/edit', 'ExaminationController@editExamination');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/edit',
  method: 'POST',
  schema: examinationSchema,
  transform: createTransform(examinationSchema, 'data'),
}

export const exam_createExamination_Api = {
  name: 'exam_createExamination',
  backend: `Route::post('examinations/{type}/{id}/add', 'ExaminationController@createExamination');`,
  root: API_ROOT_URL,
  path: '/examinations/:type/:id/add',
  method: 'POST',
  schema: examinationSchema,
  transform: createTransform(examinationSchema, 'data'),
}

export const exam_getExamQuestions_Api = {
  name: 'exam_getExamQuestions',
  backend: `Route::get('exam-questions/exam-question-sets/{id}/get-exam-questions', 'ExamQuestionController@getExamQuestions');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-sets/:id/get-exam-questions',
  method: 'GET',
}

export const exam_deleteExamQuestion_Api = {
  name: 'exam_deleteExamQuestion',
  backend: `Route::post('exam-questions/exam-question/{id}/delete', 'ExamQuestionController@deleteExamQuestion');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question/:id/delete',
  method: 'POST',
}

export const exam_editExamQuestion_Api = {
  name: 'exam_editExamQuestion',
  backend: `Route::post('exam-questions/exam-question/:id/edit', 'ExamQuestionController@editExamQuestion');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question/:id/edit',
  method: 'POST',
}

export const exam_createExamQuestion_Api = {
  name: 'exam_createExamQuestion',
  backend: `Route::post('exam-questions/exam-question-sets/{id}/create-exam-question', 'ExamQuestionController@createExamQuestion');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-sets/:id/create-exam-question',
  method: 'POST',
}

export const exam_getExamQuestionAnswers_Api = {
  name: 'exam_getExamQuestionAnswers',
  backend: `Route::get('exam-questions/exam-question/{id}/get-exam-question-answers', 'ExamQuestionController@getExamQuestionAnswers');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question/:id/get-exam-question-answers',
  method: 'GET',
}

export const exam_createExamQuestionAnswer_Api = {
  name: 'exam_createExamQuestionAnswer',
  backend: `Route::post('exam-questions/exam-question/{id}/create-exam-question-answer', 'ExamQuestionController@createExamQuestionAnswer');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question/:id/create-exam-question-answer',
  method: 'POST',
}

export const exam_editExamQuestionAnswer_Api = {
  name: 'exam_editExamQuestionAnswer',
  backend: `Route::post('exam-questions/exam-question-answer/{id}/edit', 'ExamQuestionController@editExamQuestionAnswer');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-answer/:id/edit',
  method: 'POST',
}

export const exam_deleteExamQuestionAnswer_Api = {
  name: 'exam_deleteExamQuestionAnswer',
  backend: `Route::post('exam-questions/exam-question-answer/{id}/delete', 'ExamQuestionController@deleteExamQuestionAnswer');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question-answer/:id/delete',
  method: 'POST',
}

export const exam_createExaminationInfoAnswer_Api = {
  name: 'exam_createExaminationInfoAnswer',
  backend: `Route::post('examinations/examination-info/{id}/create-examination-info-answer', 'ExaminationController@createExaminationInfoAnswer');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info/:id/create-examination-info-answer',
  method: 'POST',
}

export const exam_editExaminationInfoAnswer_Api = {
  name: 'exam_editExaminationInfoAnswer',
  backend: `Route::post('examinations/examination-info-answer/{id}/edit', 'ExaminationController@editExaminationInfoAnswer');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info-answer/:id/edit',
  method: 'POST',
}

export const exam_deleteExaminationInfoAnswer_Api = {
  name: 'exam_deleteExaminationInfoAnswer',
  backend: `Route::post('examinations/examination-info-answer/{id}/delete', 'ExaminationController@deleteExaminationInfoAnswer');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info-answer/:id/delete',
  method: 'POST',
}

export const exam_createExaminationInfo_Api = {
  name: 'exam_createExaminationInfo',
  backend: `Route::post('examinations/examination/{id}/create-examination-info', 'ExaminationController@createExaminationInfo');`,
  root: API_ROOT_URL,
  path: '/examinations/examination/:id/create-examination-info',
  method: 'POST',
}

export const exam_editExaminationInfo_Api = {
  name: 'exam_editExaminationInfo',
  backend: `Route::post('examinations/examination-info/{id}/edit', 'ExaminationController@editExaminationInfo');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info/:id/edit',
  method: 'POST',
}

export const exam_deleteExaminationInfo_Api = {
  name: 'exam_deleteExaminationInfo',
  backend: `Route::post('examinations/examination-info/{id}/delete', 'ExaminationController@deleteExaminationInfo');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info/:id/delete',
  method: 'POST',
}

export const exam_generateExaminationPaperForExportFile_Api = {
  name: 'exam_generateExaminationPaperForExportFile',
  backend: `Route::post('examinations/{id}/examination-papers/generate-export-file', 'ExaminationController@generateExaminationPaperForExportFile');`,
  root: API_ROOT_URL,
  path: '/examinations/:id/examination-papers/generate-export-file',
  method: 'POST',
}

export const exam_sortExamQuestionAnswers_Api = {
  name: 'exam_sortExamQuestionAnswers',
  backend: `Route::post('exam-questions/exam-question/{id}/sort-exam-question-answers', 'ExamQuestionController@sortExamQuestionAnswers');`,
  root: API_ROOT_URL,
  path: '/exam-questions/exam-question/:id/sort-exam-question-answers',
  method: 'POST',
}

export const exam_sortExaminationInfoAnswers_Api = {
  name: 'exam_sortExaminationInfoAnswers',
  backend: `Route::post('examinations/examination-info/{id}/sort-examination-info-answers', 'ExaminationController@sortExaminationInfoAnswers');`,
  root: API_ROOT_URL,
  path: '/examinations/examination-info/:id/sort-examination-info-answers',
  method: 'POST',
}


export const exam_fetchSuggestionExamAppChoices_Api = {
  name: 'exam_fetchSuggestionExamAppChoices_Api',
  backend: `Route::get('recommendations/examination/suggested-items', 'PromoteController@getExams');`,
  root: API_ROOT_URL,
  path: '/recommendations/examination/suggested-items',
  method: 'GET',
  paramsFields: ['category_id'],
  schema: examinationSchema,
  transform: createListTransform(examinationSchema),
}

export const exam_fetchExaminationAll_Api = {
  name: 'exam_fetchSuggestionExamAppChoices_Api',
  backend: `Route::get('examinations/get-all-examinations', 'ExaminationController@getAllExaminations');`,
  root: API_ROOT_URL,
  path: '/examinations/get-all-examinations',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword'],
  schema: examinationSchema,
  transform: createListTransform(examinationSchema),
}